import React from 'react';
import { Checkbox } from 'antd';
import { useSelectInvoicesStore } from 'shared/stores/use-select-invoices.ts';
import type { IInvoiceCheckboxProps } from 'components/invoices/invoice-checkbox/types';

export const InvoiceCheckbox: React.FC<IInvoiceCheckboxProps> = (props) => {
  const { invoiceId } = props;
  const { selectedInvoices, toggleInvoice } = useSelectInvoicesStore();

  const isSelected = selectedInvoices.has(invoiceId);

  const handleClick = () => toggleInvoice(invoiceId);

  return <Checkbox checked={isSelected} onClick={handleClick} />;
};
